import { useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_DEFAULTS } from "../data/contentDefaults";

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
export const mergeContent = (base, over) => {
  if (!isObj(over)) return base;
  const out = { ...base };
  Object.keys(over).forEach((k) => { out[k] = isObj(base[k]) ? mergeContent(base[k], over[k]) : over[k]; });
  return out;
};

let cached = null;
let pending = null;
const listeners = new Set();
export const setContentCache = (overrides) => { cached = mergeContent(CONTENT_DEFAULTS, overrides); listeners.forEach((fn) => fn(cached)); };

// Site copy: defaults merged with admin overrides from /api/content.
export const useContent = () => {
  const [c, setC] = useState(cached || CONTENT_DEFAULTS);
  useEffect(() => {
    listeners.add(setC);
    if (!cached) {
      pending = pending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/content`).then((r) => setContentCache(r.data || {}));
      pending.catch(() => { pending = null; });
    }
    return () => listeners.delete(setC);
  }, []);
  return c;
};

export const fill = (str, c, extra = {}) => {
  const vars = { mountFrom: c.prices.sizes[0], gallery: c.prices.gallery, survey: c.survey?.price ?? 79, phone: "(252) 545-0011", ...extra };
  return String(str ?? "").replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m));
};
